<app-item [entity]="morphology" *ngIf="morphology" [deleteButtonInMore]="true" [deleteService]="deleteService">
    <app-luna-button more-buttons iconName="pencil" (clickedEvent)="edit()"></app-luna-button>

    <app-summary [expandable]="true">
        <div title class="d-flex align-items-center gap flex-wrap">
            <app-date-summary-field *ngIf="displayDate && morphology.date" [date]="morphology.date"/>
            <app-bmi-summary-field label="IMC" *ngIf="morphology.height && morphology.weight" [height]="morphology.height" [weight]="morphology.weight" />
            <app-summary-field unit="EU" *ngIf="morphology.shoeSize" [value]="morphology.shoeSize" />
            <ng-container *ngIf="(!displayDate || !morphology.date) && !morphology.shoeSize">
                <app-summary-field unit="cm" *ngIf="morphology.height" [value]="morphology.height" />
                <app-summary-field unit="kg" *ngIf="morphology.weight" [value]="morphology.weight" />
            </ng-container>
        </div>
        <div expandedContent class="d-flex align-items-center gap flex-wrap">
            <ng-container *ngIf="!((!displayDate || !morphology.date) && !morphology.shoeSize)">
                <app-summary-field unit="cm" *ngIf="morphology.height" [value]="morphology.height" />
                <app-summary-field unit="kg" *ngIf="morphology.weight" [value]="morphology.weight" />
            </ng-container>
            <app-comment-summary-field *ngIf="morphology.comment" [comment]="morphology.comment"></app-comment-summary-field>
        </div>
    </app-summary>
</app-item>
